/**
 * ENNAME-3 · 对外入口（平台上架 / 社媒开放）没有真英文名时后端回 409「缺英文名，请先在产品详情补英文名」。
 * 这里只认这个错，给按钮旁的「去补」链接（跳产品详情补英文名）；判定在后端（real_english），前端不自己判断。
 */
import { Link } from "react-router-dom";
import { ApiError } from "@/services/api";

export const MISSING_EN_MARK = "缺英文名";

/** 是不是「缺英文名」这一种 409 */
export function isMissingEnglish(e: unknown): boolean {
  return e instanceof ApiError && e.status === 409 && e.message.includes(MISSING_EN_MARK);
}

/** 按钮旁的「去补」：跳到产品详情（英文名在「基本信息」里改） */
export function FixEnglishLink({ productId }: { productId: string }) {
  return (
    <Link to={`/products/${productId}`} data-testid="fix-name-en"
      className="ml-1.5 whitespace-nowrap text-[12px] font-medium text-blue-600 hover:underline">
      去补
    </Link>
  );
}
